import index from '@/components/operaPage/index'
import moreFunction from '@/components/operaPage/moreFunction'
import fangT from '@/components/operaPage/fangT'
import fangQ from '@/components/operaPage/fangQ'
import fangXQ from '@/components/operaPage/fangXQ'
import book from '@/components/operaPage/book'
import fangTXQ from '@/components/operaPage/fangTXQ'
import orderList from '@/components/operaPage/orderList'
import orderDetail from '@/components/operaPage/orderDetail'
import order from '@/components/operaPage/order'
import repair from '@/components/operaPage/repair'
import meetingOrder from '@/components/operaPage/meetingOrder'
import center from '@/components/operaPage/center'
import centerInfo from '@/components/operaPage/centerInfo'
import info from '@/components/operaPage/info'
import cityState from '@/components/operaPage/cityState'
import meetingDetail from '@/components/operaPage/meetingDetail'
import infoDetail from '@/components/operaPage/infoDetail'
import cateringOrder from '@/components/operaPage/cateringOrder'
import cateringDetail from '@/components/operaPage/cateringDetail'
import shirtReport from '@/components/operaPage/shirtReport'
import eventWorm from '@/components/operaPage/eventWorm'
import eventInfo from '@/components/operaPage/eventInfo'
import addNewEvent from '@/components/operaPage/addNewEvent'
import member from '@/components/operaPage/member'
import memberDetailPay from '@/components/operaPage/memberDetailPay'
import memberDetailCharge from '@/components/operaPage/memberDetailCharge'
import revenueCompare from '@/components/operaPage/revenueCompare'
import revenueReport from '@/components/operaPage/revenueReport'
import cashierReport from '@/components/operaPage/cashierReport'
import payReport from '@/components/operaPage/payReport'
import roomPrediectionReport from '@/components/operaPage/roomPrediectionReport'
import orderFromReport from '@/components/operaPage/orderFromReport'
import indexDetail from '@/components/operaPage/indexDetail'
import indexDesc from '@/components/operaPage/indexDesc'
import version from '@/components/operaPage/version'
import cacheMange from '@/components/operaPage/cacheMange'
import versionDetail from '@/components/operaPage/versionDetail'
import messagePush from '@/components/operaPage/messagePush'
import setting from '@/components/operaPage/setting'
import device from '@/components/operaPage/device'
import account from '@/components/operaPage/account'
import accountLocker from '@/components/operaPage/accountLocker'

import ConfigeHotel from '@/components/operaPage/ConfigeHotel'
import CouponUse from '@/components/operaPage/CouponUse'

const operaRouter = [
  {
    path: '/opera/',
    name: 'opera-index',
    component: index
  },
  {
    path: '/opera/moreFunction',
    name: 'opera-moreFunction',
    component: moreFunction
  },
  {
    path: '/opera/fangT',
    name: 'opera-fangT',
    component: fangT
  },
  {
    path: '/opera/fangQ',
    name: 'opera-fangQ',
    component: fangQ
  },
  {
    path: '/opera/fangXQ',
    name: 'opera-fangXQ',
    component: fangXQ
  },
  {
    path: '/opera/book',
    name: 'opera-book',
    component: book
  },
  {
    path: '/opera/fangTXQ',
    name: 'opera-fangTXQ',
    component: fangTXQ
  },
  {
    path: '/opera/orderList',
    name: 'opera-orderList',
    component: orderList
  },
  {
    path: '/opera/orderDetail',
    name: 'opera-orderDetail',
    component: orderDetail
  },
  {
    path: '/opera/order',
    name: 'opera-order',
    component: order
  },
  {
    path: '/opera/repair',
    name: 'opera-repair',
    component: repair
  },
  {
    path: '/opera/meetingOrder',
    name: 'opera-meetingOrder',
    component: meetingOrder
  },
  {
    path: '/opera/center',
    name: 'opera-center',
    component: center
  },
  {
    path: '/opera/centerInfo',
    name: 'opera-centerInfo',
    component: centerInfo
  },
  {
    path: '/opera/info',
    name: 'opera-info',
    component: info
  },
  {
    path: '/opera/cityState',
    name: 'opera-cityState',
    component: cityState
  },
  {
    path: '/opera/meetingDetail/:id',
    name: 'opera-meetingDetail',
    component: meetingDetail
  },
  {
    path: '/opera/infoDetail',
    name: 'opera-infoDetail',
    component: infoDetail
  },
  {
    path: '/opera/cateringOrder',
    name: 'opera-cateringOrder',
    component: cateringOrder
  },
  {
    path: '/opera/cateringDetail',
    name: 'opera-cateringDetail',
    component: cateringDetail
  },
  {
    path: '/opera/shirtReport',
    name: 'opera-shirtReport',
    component: shirtReport
  },
  {
    path: '/opera/eventWorm',
    name: 'opera-eventWorm',
    component: eventWorm
  },
  {
    path: '/opera/eventInfo',
    name: 'opera-eventInfo',
    component: eventInfo
  },
  {
    path: '/opera/addNewEvent',
    name: 'opera-addNewEvent',
    component: addNewEvent
  },
  {
    path: '/opera/member',
    name: 'opera-member',
    component: member
  },
  {
    path: '/opera/memberDetailPay',
    name: 'opera-memberDetailPay',
    component: memberDetailPay
  },
  {
    path: '/opera/memberDetailCharge',
    name: 'opera-memberDetailCharge',
    component: memberDetailCharge
  },
  {
    path: '/opera/revenueCompare',
    name: 'opera-revenueCompare',
    component: revenueCompare
  },
  {
    path: '/opera/revenueReport',
    name: 'opera-revenueReport',
    component: revenueReport
  },
  {
    path: '/opera/cashierReport',
    name: 'opera-cashierReport',
    component: cashierReport
  },
  {
    path: '/opera/payReport',
    name: 'opera-payReport',
    component: payReport
  },
  {
    path: '/opera/roomPrediectionReport',
    name: 'opera-roomPrediectionReport',
    component: roomPrediectionReport
  },
  {
    path: '/opera/orderFromReport',
    name: 'opera-orderFromReport',
    component: orderFromReport
  },
  {
    path: '/opera/indexDetail',
    name: 'opera-indexDetail',
    component: indexDetail
  },
  {
    path: '/opera/indexDesc',
    name: 'opera-indexDesc',
    component: indexDesc
  },
  {
    path: '/opera/version',
    name: 'opera-version',
    component: version
  },
  {
    path: '/opera/cacheMange',
    name: 'opera-cacheMange',
    component: cacheMange
  },
  {
    path: '/opera/versionDetail',
    name: 'opera-versionDetail',
    component: versionDetail
  },
  {
    path: '/opera/ConfigeHotel',
    name: 'opera-ConfigeHotel',
    component: ConfigeHotel
  },
  {
    path: '/opera/CouponUse',
    name: 'opera-CouponUse',
    component: CouponUse
  },
  {
    path: '/opera/messagePush',
    name: 'opera-messagePush',
    component: messagePush
  },
  {
    path: '/opera/setting',
    name: 'opera-setting',
    component: setting
  },
  {
    path: '/opera/device',
    name: 'opera-device',
    component: device
  },
  {
    path: '/opera/account',
    name: 'opera-account',
    component: account
  },
  {
    path: '/opera/accountLocker',
    name: 'opera-accountLocker',
    component: accountLocker
  },

  // 系统参数设置
  {
    path: '/opera/sysOption/sysOptionList',
    name: 'opera-sysOptionList',
    component: () =>
      import ('@/components/operaPage/sysOption/sysOptionList')
  },
  {
    path: '/opera/sysOption/sysOptionEdit',
    name: 'opera-sysOptionEdit',
    component: () =>
      import ('@/components/operaPage/sysOption/sysOptionEdit')
  },
]

export default operaRouter



// WEBPACK FOOTER //
// ./src/router/operaRouter.js